<template>
  <div v-if="carregaModel" :submit="ConsultaDataBusca">
    <v-card>
      <v-row class="d-flex justify-center">
          <v-card-title class="text-h5 primary--text">Resultado da Consulta</v-card-title>
      </v-row>
      <v-row class="justify-end">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
              <v-btn label="teste" class="mr-3 mb-3" v-bind="attrs" v-on="on" depressed color="primary"
                  @click="exportaBureauDataBusca" data-cy="exportarPDF">
                  <v-icon>ph-file-pdf</v-icon>
              </v-btn>
          </template>
          <span>Exportar PDF</span>
        </v-tooltip>
      </v-row>
      <v-card-text>
        <span class="text-h5 ml-3 primary--text">Dados da Consulta</span>
        <v-divider></v-divider>
        <v-row>
          <v-col cols="3" class="mt-3 mb-5">
              <v-row class="text-subtitle"> Nome </v-row>
              <v-row class="text-subtitle"> {{ model.Name }} </v-row>
          </v-col>
          <v-col cols="3" class="mt-3 mb-5">
              <v-row class="text-subtitle"> Documento </v-row>
              <v-row class="text-subtitle"> {{ model.DocumentFormatted }} </v-row>
          </v-col>
          <v-col cols="3" class="mt-3 mb-5" v-if="isPessoaPF">
              <v-row class="text-subtitle"> Dt. Nasc. </v-row>
              <v-row class="text-subtitle"> {{ $api.UI.Format.Date($api.UI.Parse.Date(model.BirthDate)) }} </v-row>
          </v-col>
          <v-col cols="3" class="mt-3 mb-5" v-else>
            <v-row class="text-subtitle">Data de Criação</v-row>
            <v-row class="text-subtitle">{{ $api.UI.Format.Date($api.UI.Parse.Date(model.CreateDate)) }}</v-row>
          </v-col>
          <v-col cols="3" class="mt-3 mb-5" v-if="model.DeathDate">
            <v-row class="text-subtitle"> Data de Fechamento </v-row>
            <v-row class="text-subtitle"> {{ $api.UI.Format.Date($api.UI.Parse.Date(model.DeathDate)) }} </v-row>
          </v-col>
          <v-col cols="3" class="mt-3 mb-5">
            <v-row class="text-subtitle"> Idade </v-row>
            <v-row class="text-subtitle"> {{ model.Age }} anos </v-row>
          </v-col>
          <v-col cols="3" class="mt-3 mb-5" v-if="isPessoaPF">
              <v-row class="text-subtitle"> Sexo </v-row>
              <v-row class="text-subtitle"> {{ model.Gender === 1 ? "Masculino" : "Feminino" }} </v-row>
          </v-col>
        </v-row>

        <template v-if="model.Activities">
          <span class="text-h5 ml-3 primary--text">Atividades</span>
          <v-divider></v-divider>
          <v-row class="mb-5">
            <v-col cols="3" class="mt-3 mb-5" v-for="(item, i) in model.Activities" :key="i">
              <v-row class="text-subtitle">
                {{ item.Description }}
              </v-row>
            </v-col>
          </v-row>
        </template>

        <template v-if="model.FiscalSituation">
          <span class="text-h5 ml-3 primary--text">Situação Receita Federal</span>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> Situação Fiscal </v-row>
                <v-row class="text-subtitle"> {{ model.FiscalSituation.Description }} </v-row>
            </v-col>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> Score Atual </v-row>
                <v-row class="text-subtitle"> {{ model.CreditScore.D00 }} </v-row>
            </v-col>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> Score 30 dias </v-row>
                <v-row class="text-subtitle"> {{ model.CreditScore.D30 }} </v-row>
            </v-col>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> Score 60 dias </v-row>
                <v-row class="text-subtitle"> {{ model.CreditScore.D60 }} </v-row>
            </v-col>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> Score 90 dias </v-row>
                <v-row class="text-subtitle"> {{ model.CreditScore.D90 }} </v-row>
            </v-col>
          </v-row>
        </template>

        <template v-if="model.Affiliateds">
          <span class="text-h5 ml-3 primary--text">Afiliados</span>
          <v-divider></v-divider>
          <v-simple-table class="mb-5">
            <template v-slot:default>
              <tbody>
                <tr v-for="i in (model.Affiliateds && model.AffiliatedsLength ? model.AffiliatedsLength : 0)" :key="i">
                  <template v-if="i < 4 || verTodosAfiliados">
                    <td class="pt-4 pb-4" v-for="k in 4" :key="k">
                      {{ model.Affiliateds[((i-1) * 4 + k) - 1] ? model.Affiliateds[((i-1) * 4 + k) - 1].Name : '' }}
                      {{ model.Affiliateds[((i-1) * 4 + k) - 1] ? model.Affiliateds[((i-1) * 4 + k) - 1].DocumentFormatted : '' }}
                    </td>
                  </template>
                  <td role="button" v-else-if="i === 4" colspan="4"
                      class="text-decoration-underline primary--text" @click="verTodosAfiliados = true">
                    ver todos os afiliados
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>

        <template v-if="model.CorrelatedCompanies && model.CorrelatedCompanies.length > 0">
          <span class="text-h5 ml-3 primary--text">Empresas Correlacionadas</span>
          <v-divider></v-divider>
          <v-row class="mb-5">
            <v-col cols="6" class="text-subtitle" v-for="(item, i) in model.CorrelatedCompanies" :key="i">
              <v-row class="text-subtitle"> {{ item.Name }} </v-row>
              <v-row class="text-subtitle"> {{ item.DocumentFormatted }} </v-row>
            </v-col>
          </v-row>
        </template>

        <template v-if="model.Relateds">
          <span class="text-h5 ml-3 primary--text">Pessoas Relacionadas</span>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="3" class="mt-3 mb-5" v-for="(item, i) in model.Relateds" :key="i">
              <span class="text-caption font-weight-bold" v-if="model.Person && model.Person.MotherName === item.Name"> Mãe </span>
              <v-row class="text-subtitle">
                {{ item.Name }}
              </v-row>
            </v-col>
          </v-row>
        </template>

        <template v-if="model.Restrictions">
          <span class="text-h5 ml-3 primary--text">Restrições</span>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="6" class="mt-3 mb-5" v-for="i in model.Restrictions" :key="i.Description">
                <v-row class="text-subtitle"> Descrição </v-row>
                <v-row class="text-subtitle"> {{ i.Description }} </v-row>
            </v-col>
          </v-row>
        </template>

        <template v-if="model.Vehicles">
          <span class="text-h5 ml-3 primary--text">Veículos</span>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="4" class="mt-3 mb-5" v-for="(item, i) in model.Vehicles" :key="i">
              <v-row class="text-subtitle"> {{ item.Model }} </v-row>
              <v-row class="text-subtitle"> {{ item.Brand }} </v-row>
              <v-row class="text-subtitle"> Placa: {{ item.LicensePlate }} </v-row>
              <v-row class="text-subtitle"> Ano: {{ item.YearModel }} </v-row>
              <v-row class="text-subtitle"> Fipe: {{ item.FipePrice }} </v-row>
              <template v-if="item.PreviousOwner">
                <v-row class="text-subtitle"> Dono Anterior: {{ item.PreviousOwner.Name }} </v-row>
                <v-row class="text-subtitle"> Documento Dono Anterior: {{ item.PreviousOwner.DocumentFormatted }} </v-row>
              </template>
              <template v-if="item.NextOwner">
                <v-row class="text-subtitle"> Próximo Dono: {{ item.NextOwner.Name }} </v-row>
                <v-row class="text-subtitle"> Documento Próximo Dono: {{ item.NextOwner.DocumentFormatted }} </v-row>
              </template>
            </v-col>
          </v-row>
        </template>

        <template v-if="model.WebSites">
          <span class="text-h5 ml-3 primary--text">WebSites</span>
          <v-divider></v-divider>
          <v-row class="mb-5">
            <v-col cols="4" class="text-subtitle" v-for="(item, i) in model.WebSites" :key="i">
              <v-row class="text-subtitle"> URL: {{ item.URL }} </v-row>
              <v-row class="text-subtitle"> País: {{ item.WebTraffic.Country }} </v-row>
              <v-row class="text-subtitle"> Data de Criação {{ $api.UI.Format.Date($api.UI.Parse.Date(item.CreateDate)) }} </v-row>
            </v-col>
          </v-row>
        </template>

        <template v-if="model.Emails && model.Emails?.length > 0 && model.Emails.some(dadosEmail => dadosEmail.Email != null)">
          <span class="text-h5 ml-3 primary--text">E-mail</span>
          <v-divider></v-divider>
          <v-simple-table class="mb-5">
            <template v-slot:default>
              <tbody>
                <template ></template>
                <tr v-for="i in (model.Emails && model.EmailsLength ? model.EmailsLength : 0)" :key="i">
                  <template v-if="i < 3 || verTodosEmails">
                    <td class="" v-for="k in 3" :key="k"> {{ model.Emails[((i-1) * 3 + k) - 1] ? model.Emails[((i-1) * 3 + k) - 1].Email : '' }} </td>
                  </template>
                  <td role="button" v-else-if="i === 3" colspan="4" class="text-decoration-underline primary--text" @click="verTodosEmails = true">
                    ver todos os emails
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>

        <template v-if="model.Phones">
          <span class="text-h5 ml-3 primary--text">Telefones</span>
          <v-divider></v-divider>
          <v-simple-table class="mb-5">
            <template v-slot:default>
              <tbody>
                <tr v-for="i in (model.Phones && model.PhoneLength ? model.PhoneLength : 0)" :key="i">
                  <template v-if="i < 4 || verTodosTelefones">
                    <td class="" v-for="k in 4" :key="k"> {{ model.Phones[((i-1) * 4 + k) - 1] ? model.Phones[((i-1) * 4 + k) - 1].FormattedNumber : '' }} </td>
                  </template>
                  <td role="button" v-else-if="i === 4" colspan="4"
                      class="text-decoration-underline primary--text" @click="verTodosTelefones = true">
                    ver todos os telefones
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </template>

        <template v-if="model.BankReferences">
            <span class="text-h5 ml-3 primary--text">Referências Bancárias</span>
            <v-divider></v-divider>
            <v-simple-table class="mb-5">
            <template v-slot:default>
              <tbody>
                <tr v-for="i in (model.BankReferences && model.BankReferencesLength ? model.BankReferencesLength : 0)" :key="i">
                  <template v-if="i < 4 || verTodasReferenciasBancarias">
                    <td class="pt-4 pb-4" v-for="k in 4" :key="k">
                      {{ model.BankReferences[((i-1) * 4 + k) - 1] ? model.BankReferences[((i-1) * 4 + k) - 1].Name : '' }}
                      <br />
                      <template v-if="model.BankReferences[((i-1) * 4 + k) - 1] && model.BankReferences[((i-1) * 4 + k) - 1].Agency ">
                        Agência: {{ model.BankReferences[((i-1) * 4 + k) - 1] ? model.BankReferences[((i-1) * 4 + k) - 1].Agency : '' }}
                      </template>
                    </td>
                  </template>
                  <td role="button" v-else-if="i === 4" colspan="4"
                      class="text-decoration-underline primary--text" @click="verTodasReferenciasBancarias = true">
                    ver todos as referências
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          </template>

          <template v-if="model.Addresses">
          <span class="text-h5 ml-3 primary--text">Endereço</span>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="3" class="mt-3 mb-5">
              <v-row class="text-subtitle"> Endereço </v-row>
              <v-row class="text-subtitle"> {{ model.Addresses[0].ShortAlias }} </v-row>
            </v-col>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> Complemento </v-row>
                <v-row class="text-subtitle"> {{ model.Addresses[0].ComplementFormatted ? model.Addresses[0].ComplementFormatted : "-" }} </v-row>
            </v-col>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> Bairro </v-row>
                <v-row class="text-subtitle"> {{ model.Addresses[0].District }} </v-row>
            </v-col>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> Número </v-row>
                <v-row class="text-subtitle"> {{ model.Addresses[0].Number }} </v-row>
            </v-col>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> CEP </v-row>
                <v-row class="text-subtitle"> {{ $api.UI.Format.Cep($api.UI.Format.LeftPadNumbers(model.Addresses[0].ZipCode, 8, 0)) }} </v-row>
            </v-col>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> Cidade </v-row>
                <v-row class="text-subtitle"> {{ model.Addresses[0].City }} </v-row>
            </v-col>
            <v-col cols="3" class="mt-3 mb-5">
                <v-row class="text-subtitle"> UF </v-row>
                <v-row class="text-subtitle"> {{ model.Addresses[0].State }} </v-row>
            </v-col>
          </v-row>
        </template>

        <template v-if="model.Addresses && model.Addresses.length > 1">
          <v-expansion-panels focusable>
            <v-expansion-panel>
                <v-expansion-panel-header class="primary--text">Outros Endereços</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row v-for="(item, i) in model.Addresses" :key="`address_${i}`">
                    <template v-if="i > 1">
                      <v-col cols="4" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Endereço </v-row>
                        <v-row class="text-subtitle"> {{ item.ShortAlias }} </v-row>
                      </v-col>
                      <v-col cols="3" class="mt-3 mb-5">
                          <v-row class="text-subtitle"> Complemento </v-row>
                          <v-row class="text-subtitle"> {{ item.ComplementFormatted }} </v-row>
                      </v-col>
                      <v-col cols="3" class="mt-3 mb-5">
                          <v-row class="text-subtitle"> Bairro </v-row>
                          <v-row class="text-subtitle"> {{ item.District }} </v-row>
                      </v-col>
                      <v-col cols="2" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Número </v-row>
                        <v-row class="text-subtitle"> {{ item.Number }} </v-row>
                      </v-col>
                      <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> CEP </v-row>
                          <v-row class="text-subtitle"> {{ $api.UI.Format.Cep($api.UI.Format.LeftPadNumbers(model.Addresses[0].ZipCode, 8, 0)) }} </v-row>
                      </v-col>
                      <v-col cols="3" class="mt-3 mb-5">
                          <v-row class="text-subtitle"> Cidade </v-row>
                          <v-row class="text-subtitle"> {{ item.City }} </v-row>
                        </v-col>
                        <v-col cols="3" class="mt-3 mb-5">
                          <v-row class="text-subtitle"> UF </v-row>
                          <v-row class="text-subtitle"> {{ item.State }} </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-divider></v-divider>
                      </v-col>
                    </template>
                  </v-row>

                  <v-row v-for="(item, i) in model.BusinessAddresses" :key="`businessAddress_${i}`">
                    <span class="ml-3 primary--text">Endereço Comercial</span>
                    <v-col cols="4" class="mt-3 mb-5">
                      <v-row class="text-subtitle"> Endereço </v-row>
                      <v-row class="text-subtitle"> {{ item.ShortAlias }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Complemento </v-row>
                        <v-row class="text-subtitle"> {{ item.ComplementFormatted }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Bairro </v-row>
                        <v-row class="text-subtitle"> {{ item.District }} </v-row>
                    </v-col>
                    <v-col cols="2" class="mt-3 mb-5">
                      <v-row class="text-subtitle"> Número </v-row>
                      <v-row class="text-subtitle"> {{ item.Number }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                      <v-row class="text-subtitle"> CEP </v-row>
                        <v-row class="text-subtitle"> {{item.ZipCode }} </v-row>
                    </v-col>
                    <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> Cidade </v-row>
                        <v-row class="text-subtitle"> {{ item.City }} </v-row>
                      </v-col>
                      <v-col cols="3" class="mt-3 mb-5">
                        <v-row class="text-subtitle"> UF </v-row>
                        <v-row class="text-subtitle"> {{ item.State }} </v-row>
                    </v-col>
                    <v-col cols="12">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      model: {},
      carregaModel: false,
      verTodosTelefones: false,
      verTodosAfiliados: false,
      verTodasReferenciasBancarias: false,
      verTodosEmails: false
    }
  },
  methods: {
    ConsultaDataBusca (documento) {
      const th = this

      th.model = {}
      th.carregaModel = false

      var dto = {
        consulta: {
          Documento: documento
        }
      }

      th.$api.Multiplo.Post('ConsultaDataBusca', dto).then((response) => {
        if (response.HasError || response.Falha || response.error) {
          th.$emit('error')
          th.$api.UI.ShowError('Erro', response.Msg || response.error)
        } else {
          th.$api.UTIL.SetAllButNull(th, 'model', JSON.parse(response.JSON))

          if (th.model.Activities) {
            const AtividadesFiltradas = th.model.Activities.filter(({ Description }) => Description)
            th.$set(th.model, 'Activities', AtividadesFiltradas)
          }

          const DtNascimento = th.model.BirthDate.replace('Z', '')
          th.$set(th.model, 'BirthDate', DtNascimento)

          th.carregaModel = true

          if (th.model.Phones && th.model.Phones.length > 0) {
            var phoneLength = th.model.Phones.length / 4
            var validaInteiroPhone = Math.ceil(phoneLength)
            th.$set(th.model, 'PhoneLength', validaInteiroPhone)
          }

          if (th.model.Affiliateds && th.model.Affiliateds.length > 0) {
            var AffiliatedsLength = th.model.Affiliateds.length / 4
            var validaInteiroAffiliateds = Math.ceil(AffiliatedsLength)
            th.$set(th.model, 'AffiliatedsLength', validaInteiroAffiliateds)
          }

          if (th.model.BankReferences && th.model.BankReferences.length > 0) {
            var BankReferencesLength = th.model.BankReferences.length / 4
            var validaInteiroBankReferences = Math.ceil(BankReferencesLength)
            th.$set(th.model, 'BankReferencesLength', validaInteiroBankReferences)
          }

          if (th.model.Emails && th.model.Emails.length > 0) {
            var emailsLength = th.model.Emails.length / 3
            var validaInteiroEmail = Math.ceil(emailsLength)
            th.$set(th.model, 'EmailsLength', validaInteiroEmail)
          }
        }
      })
    },
    exportaBureauDataBusca (tipo) {
      const th = this
      var dto = {
        consulta: th.model
      }
      th.$api.Bureau.GerarPDFDataBusca(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.downloadBureau(response.data, tipo)
        }
      })
    },
    downloadBureau (file, tipo) {
      var nomeArquivo = 'Data Busca - ' + this.model.DocumentFormatted + '.pdf'
      var blob = tipo === 1 ? new Blob(['\ufeff', file], { type: 'text/csv' + ';charset=utf-8' }) : file;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
    }
  },
  computed: {
    isPessoaPF () {
      return this.model.DocumentFormatted.length <= 14
    }
  }
}
</script>
